<template>
	<div class="page-section container-fluid text-center MessageBoard">
		<div>
			<div class="button">
				<div @click="pattern = false" :style="!pattern ? 'color:lightskyblue' : ''">
					留言板
				</div>
				<div @click="pattern = true" :style="pattern ? 'color:lightskyblue' : ''">
					智能聊天
				</div>

			</div>
			<transition mode="out-in">
				<component @data1="(i) => (data1 = i)" :data1="data1" @data2="(i) => (data2 = i)" :data2="data2"
					:is="pattern ? 'Intelligence' : 'LeavingAmessage'"></component>
			</transition>
		</div>
	</div>
</template>

<script>
	import Intelligence from "./chat/intelligence.vue";
	import LeavingAmessage from "./chat/LeavingAmessage.vue";
	export default {
		name: "MessageBoard",
		components: {
			LeavingAmessage,
			Intelligence,
		},
		data() {
			return {
				pattern: false,
				data1: [],
				data2: [],
			};
		},
		methods: {},
	};
</script>

<style scoped>
	.MessageBoard {
		width: 600px;
		padding-bottom: 0;
	}

	.MessageBoard>div {
		padding: 10px;
		border: 1px solid gray;
		border-radius: 3px;
		background: linear-gradient(to bottom,
				rgba(27, 27, 27, 0.3) 0%,
				rgba(27, 27, 27, 0.3) 100%),
			url("../assets/Background/background-6.jpg");
		background-position: center;
		background-repeat: no-repeat;
		background-attachment: scroll;
		background-size: cover;
	}

	.button {
		display: flex;
		flex-direction: row;
	}

	.button>* {
		width: 50%;
		cursor: pointer;
		padding: 10px;
	}

	@media screen and (max-width: 640px) {
		.MessageBoard {
			width: calc(100% - 40px);
		}
	}

	.v-leave-to,
	.v-enter {
		opacity: 0;
	}

	.v-enter-active,
	.v-leave-active {
		transition: all 0.2s ease-in-out;
	}
</style>
